import * as yup from 'yup';
import type { IValidationField } from '../types';

export default function customer({ label = '' }: IValidationField) {
  return yup
    .object()
    .shape({
      customerReference: yup.string().label(label).required().default(''),
      customerName: yup.string().nullable().default(''),
    })
    .required()
    .default({});
}
